import React from 'react';
import Adder from './Adder';
import formats from '../../utils/formats';

export default function Review(props) {
    const { product } = props;

    return (
        <div className="review mb-4 py-6 border-b border-grey-200">
            <div className="flex">
                <div className="flex-1">
                    <p className='font-bold'>{formats.capitalize(product.name)}</p>
                    <p className="font-thin">{formats.formatPrice(product.price)}</p>
                </div>

                <Adder product={product} />
            </div>

            {product.note ? <p className="w-full mt-2 text-sm">Note: {product.note}</p> : null}
        </div>
    );
}
